import {
    Button, Card, Col, Form, Input, Row,
    Select,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { useState } from 'react';
import { useNotification } from '../hooks/useNotification';
import { getRequiredFieldMessage } from '../helpers/form';
import PhoneInput from '../components/phone-input';
import { useNotificationDestinationTypes } from '../hooks/useNotificationDestinationTypes';

function NotificationPage() {
    const dt = useNotificationDestinationTypes();
    const { form, loading, save } = useNotification();
    const [destinationType, setDestinationType] = useState<'EMAIL'|'SMS'>();
    const { t } = useTranslation();

    return (
        <Card title={t('notification')}>
            <Form form={form} layout="vertical" onFinish={save}>
                <Row gutter={10}>
                    <Col xs={24} md={16} xl={12}>
                        <Form.Item
                            name="title"
                            label={t('title')}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col xs={24} md={16} xl={12}>
                        <Form.Item
                            name="message"
                            label={t('message')}
                            rules={[{ required: true, message: getRequiredFieldMessage(t('message')) }]}
                        >
                            <Input.TextArea />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    <Col xs={24} md={16} xl={12}>
                        <Form.Item
                            name="destination"
                            label={t('destinationType')}
                            rules={[{ required: true, message: getRequiredFieldMessage(t('destinationType')) }]}
                        >
                            <Select options={dt.data} loading={dt.loading} onSelect={setDestinationType} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={10}>
                    {destinationType === 'EMAIL' && (
                        <Col xs={24} md={16} xl={12}>
                            <Form.Item
                                name="recipient"
                                label={t('email')}
                                rules={[{ required: true, message: getRequiredFieldMessage(t('email')) }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    )}
                    {destinationType === 'SMS' && (
                        <Col xs={24} md={16} xl={12}>
                            <Form.Item
                                name="recipient"
                                label={t('orderRecipient')}
                                rules={[
                                    { required: true, message: getRequiredFieldMessage(t('orderRecipient')) },
                                    { pattern: new RegExp('^[^А-Яа-я]*$'), message: t('inputOfLatinLetters') as string },
                                    {
                                        validator: async (_: any, value: string) => {
                                            if (!isValidPhoneNumber(value, 'RU' as CountryCode)) {
                                                throw new Error(t('incorrectPhoneNumber') as string);
                                            }
                                        },
                                    },
                                ]}
                            >
                                <PhoneInput defaultCountry="RU" country="RU" />
                            </Form.Item>
                        </Col>
                    )}
                </Row>
                <Row>
                    <Button
                        type="primary"
                        htmlType="submit"
                        icon={<SaveOutlined />}
                        loading={loading}
                    >
                        {t('save')}
                    </Button>
                </Row>
            </Form>
        </Card>
    );
}

export default NotificationPage;
